// Purpose: render a LegalNotice's structured blocks as semantic, CSP-safe
// React elements (elements only, never raw HTML strings — Trusted Types is
// enforced in prod). Headings use <h3> so the notice sits under a page or
// modal <h2>.

import type { LegalNotice, NoticeBlock } from '@ast/legal-notices';

function Block({ block, keyBase }: { block: NoticeBlock; keyBase: string }) {
  switch (block.kind) {
    case 'heading':
      return <h3 className="text-body-l font-semibold text-fg-primary mt-6 mb-2">{block.text}</h3>;
    case 'paragraph':
      return <p className="text-body-s text-fg-secondary mb-3 leading-relaxed">{block.text}</p>;
    case 'list':
      return (
        <ul className="list-disc pl-5 mb-3 space-y-1">
          {block.items.map((item, i) => (
            <li
              key={`${keyBase}-li-${i}`}
              className="text-body-s text-fg-secondary leading-relaxed"
            >
              {item}
            </li>
          ))}
        </ul>
      );
  }
}

export function NoticeRenderer({ notice }: { notice: LegalNotice }) {
  return (
    <div data-testid={`notice-${notice.id}`}>
      {notice.blocks.map((block, i) => (
        <Block key={`${notice.id}-b-${i}`} block={block} keyBase={`${notice.id}-b-${i}`} />
      ))}
    </div>
  );
}
